'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uuid;
var i = 0;
var now = 0;
var prefix = Math.random().toString(36).slice(2);

function uuid() {
  var currentNow = Date.now();
  if (currentNow > now) {
    now = currentNow;
    i = 0;
  }
  return prefix + '-' + now + '-' + i++;
}